<style lang="scss" scoped>
.img-container {
	position: relative;
	display: inline-block;
	&:hover {
		.img-container__overlay {
			display: block;
		}
	}
	&__teacher {
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		height: 100%;
		width: 100%;
	}
	&__overlay {
		display: none;
		position: absolute;
		height: 40px;
		width: 40px;
		line-height: 45px;
		text-align: center;
		font-size: 20px;
		background: #ff4949;
		color: white;
		border-radius: 50%;
	}
}
</style>

<template lang="pug">
    div(:class="{ 'img-container': displayOverlay }")
        .img-container__teacher(v-if="displayOverlay", @click="$emit('click')")
            .img-container__overlay(:style="overlayPosition")
                i(:class="`fa ${overlayIcon}`")
        IconImage(:icon="icon", :size="size")
</template>

<script>
import { isEqual } from "lodash";
import IconImage from "@/components/ui/IconImage";

export default {
	components: {
		IconImage
	},
	props: {
		icon: {
			type: [String, Object],
			required: true,
			validator: value => {
				// If String
				if (typeof value === "string") return true;

				// If Object
				delete value.__typename;
				return isEqual(Object.keys(value), ["type", "value"]);
			}
		},
		displayOverlay: {
			type: Boolean,
			default: false
		},
		overlayIcon: {
			type: String,
			default: "fa-cog"
		},
		size: {
			type: Number,
			default: 110
		}
	},
	computed: {
		overlayPosition() {
			const position = this.size / 2 - 20;

			return {
				top: `${position}px`,
				right: `${position}px`
			};
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/classroom/ClassIcon.vue